<router-outlet name="home"></router-outlet>
